module.exports = __webpack_public_path__ + "media/images/recruit/common/icon-open-a94e991a53b7bafbb564dc16e2a02f12.svg";